(() => {
  'use strict';
  const roots = '[data-hok-about-story]';
  function initialize(root) {
    if (root.dataset.hokAboutReady) return;
    const dataNode = root.querySelector('[data-hok-about-photos]');
    const dialog = root.querySelector('.photo-dialog');
    if (!dataNode || !dialog) return;
    const data = JSON.parse(dataNode.textContent);
    const image = dialog.querySelector('[data-dialog-image]');
    const caption = dialog.querySelector('[data-dialog-caption]');
    const count = dialog.querySelector('[data-dialog-count]');
    const label = dialog.querySelector('[data-dialog-label]');
    const note = dialog.querySelector('[data-dialog-note]');
    const close = dialog.querySelector('[data-photo-close]');
    const previous = dialog.querySelector('[data-photo-prev]');
    const next = dialog.querySelector('[data-photo-next]');
    let group = 'heritage';
    let index = 0;
    let opener;
    let scrollLock;
    function render() {
      const photos = data[group];
      const photo = photos[index];
      image.src = photo.src;
      image.alt = photo.alt;
      caption.textContent = photo.caption;
      count.textContent = `${index + 1} / ${photos.length}`;
      label.textContent = group === 'heritage' ? 'The family trades' : group === 'machines' ? 'VYKIN Crushers' : 'House of Koval today';
      note.textContent = group === 'heritage' ? 'Retouched illustrations of our family history.' : group === 'machines' ? 'Original photographs from VYKIN Crushers.' : '';
      note.hidden = !note.textContent;
      previous.hidden = next.hidden = photos.length < 2;
    }
    function advance(step) {
      index = (index + step + data[group].length) % data[group].length;
      render();
    }
    function restoreScroll() {
      if (!scrollLock) return;
      const {element, value, priority} = scrollLock;
      if (value) element.style.setProperty('overflow', value, priority);
      else element.style.removeProperty('overflow');
      scrollLock = null;
    }
    root.querySelectorAll('[data-lightbox]').forEach(button => {
      button.addEventListener('click', () => {
        const chosenGroup = button.dataset.lightbox;
        const chosenIndex = Number(button.dataset.photo);
        if (!data[chosenGroup]?.[chosenIndex]) return;
        opener = button;
        group = chosenGroup;
        index = chosenIndex;
        render();
        // The native modal handles focus containment and Escape. Preserve the theme's
        // previous scroll state, including themes that use a separate page scroller.
        const scroller = root.closest('.page-wrapper') || document.documentElement;
        scrollLock = {element: scroller, value: scroller.style.getPropertyValue('overflow'), priority: scroller.style.getPropertyPriority('overflow')};
        scroller.style.setProperty('overflow', 'hidden');
        dialog.showModal();
        close.focus({preventScroll: true});
      });
    });
    close.addEventListener('click', () => dialog.close());
    previous.addEventListener('click', () => advance(-1));
    next.addEventListener('click', () => advance(1));
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); advance(-1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); advance(1); }
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      restoreScroll();
      if (opener?.isConnected) opener.focus({preventScroll: true});
    });
    (root.closest('.shopify-section') || root).addEventListener('shopify:section:unload', () => {
      if (dialog.open) dialog.close();
      restoreScroll();
    });
    root.dataset.hokAboutReady = 'true';
  }
  function scan(scope = document) {
    if (scope.matches?.(roots)) initialize(scope);
    scope.querySelectorAll(roots).forEach(initialize);
  }
  scan();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), {once: true});
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
